import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import moment from "moment";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { isEmpty } from "lodash";
import PromotionDetail from "../component/PromotionDetail";
import ConditionalOutsideClick from "../component/ConditionalOutsideClick";
import Layout from "./Layout";

const Promotions = () => {
  const [show, setShow] = useState({});
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const getFilteredOfferList = (count, list) => {
    const depositKeysToRemove = [
      "OnFirstDeposit",
      "OnSecondDeposit",
      "OnThirdDeposit",
      "OneFourthDeposit",
    ];

    const keysToRemove = depositKeysToRemove.slice(0, count);
    return list.filter((offer) => !keysToRemove.includes(offer.offerOn));
  };

  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getPromotional);
    if (status == 200) {
      if (data?.success) {
        let updated = getFilteredOfferList(
          profileData?.userDepositCount,
          data?.results?.offerList,
        );
        setData(updated);
      }
    }
  };

  useEffect(() => {
    getData();
  }, [profileData]);
  function getTimeDifferenceString(currentTime, endTime) {
    const now = moment(currentTime);
    const end = moment(endTime);

    if (end.isBefore(now)) {
      return t("Ended");
    }

    const duration = moment.duration(end.diff(now));
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();

    return `${t("EndIn")} ${days} ${t("days")} ${hours} ${t("hours")}`;
  }

  return (
    <Layout>
      <app-popup-page
        _ngcontent-serverapp-c2746482659
        className="ng-tns-c2746482659-0 popup-page-wrapper active"
        _nghost-serverapp-c2790459173
      >
        <div
          _ngcontent-serverapp-c2790459173
          className="popup-page popup-page--active popup-page--align-top"
        >
          {" "}
          <div
            _ngcontent-serverapp-c2790459173=""
            class="popup-page__backdrop"
          ></div>
          <ConditionalOutsideClick onOutsideClick={() => navigate(-1)}>
            <div
              _ngcontent-serverapp-c2790459173
              className="popup-page__main popup-page-main popup-page-main--show"
            >
              <div
                _ngcontent-serverapp-c2790459173
                className="popup-page-main__header"
              >
                <div
                  _ngcontent-serverapp-c2790459173
                  className="popup-page-main__title"
                >
                  {t("PROMOITIONS")}
                </div>
                <div
                  onClick={() => navigate("/")}
                  _ngcontent-serverapp-c2790459173
                  className="popup-page-main__close ng-star-inserted"
                />
              </div>
              <div
                _ngcontent-serverapp-c2790459173
                className="popup-page-main__container"
              >
                <div _ngcontent-serverapp-c2790459173 className="content">
                  <router-outlet
                    _ngcontent-serverapp-c2790459173
                    name="popup"
                  />
                  <ng-component className="ng-star-inserted">
                    <router-outlet />
                    <ng-component
                      _nghost-serverapp-c2812446712
                      className="ng-tns-c2812446712-981 ng-star-inserted"
                    >
                      <div
                        _ngcontent-serverapp-c2812446712
                        className="content-main ng-tns-c2812446712-981 ng-star-inserted"
                      >
                        <div
                          _ngcontent-serverapp-c2812446712
                          className="content-box ng-tns-c2812446712-981"
                        >
                          <div
                            _ngcontent-serverapp-c2812446712
                            className="promotion ng-tns-c2812446712-981"
                          >
         

                            <div
                              _ngcontent-serverapp-c2812446712
                              className="promotion-main promotion-main-scroll-wrap ng-tns-c2812446712-981 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted"
                            >
                              <app-waterfall-scroll
                                _ngcontent-serverapp-c2812446712
                                className="ng-tns-c2812446712-981"
                                _nghost-serverapp-c302379289
                              >
                                {data?.map((res) => {
                                  return (
                                    <div
                                      _ngcontent-serverapp-c3492280817
                                      className="promotion-box promotion-toggle ng-tns-c3492280817-983 ng-star-inserted"
                                    >
                                      <div
                                        _ngcontent-serverapp-c3492280817
                                        drcneuaexpose
                                        className="pic ng-tns-c3492280817-983"
                                      >
                                        <img
                                          _ngcontent-serverapp-c3492280817
                                          className="ng-tns-c3492280817-983"
                                          alt="image_259054"
                                          src={`${process.env.REACT_APP_API_BASE_URL}${res?.descriptionImage}`}
                                          loading="lazy"
                                        />
                                      </div>
                                      <div
                                        _ngcontent-serverapp-c3492280817
                                        className="promotion-box-inner content-style ng-tns-c3492280817-983"
                                      >
                                        <div
                                          _ngcontent-serverapp-c3492280817
                                          className="text-main ng-tns-c3492280817-983"
                                          style={{ textAlign: "left" }}
                                        >
                                          <h3
                                            _ngcontent-serverapp-c3492280817
                                            className="ng-tns-c3492280817-983"
                                          >
                                            {res?.title}
                                          </h3>
                                        </div>
                                        <div
                                          _ngcontent-serverapp-c3492280817
                                          className="times ng-tns-c3492280817-983"
                                        >
                                          <i
                                            _ngcontent-serverapp-c3492280817
                                            className="ng-tns-c3492280817-983"
                                            style={{
                                              maskImage:
                                                'url("/assets/NewIcon/icon-clock.svg")',
                                            }}
                                          />
                                          <span
                                            _ngcontent-serverapp-c3492280817
                                            className="ng-tns-c3492280817-983 ng-star-inserted"
                                          >
                                            {moment(
                                              res?.offerStartDateTime,
                                            ).format(
                                              "YYYY/MM/DD HH:MM:SS",
                                            )}{" "}
                                            ~{" "}
                                            {moment(
                                              res?.offerEndDateTime,
                                            ).format("YYYY/MM/DD HH:MM:SS")}
                                          </span>
                                        </div>
                                        <div
                                          _ngcontent-serverapp-c3492280817
                                          className="button-box ng-tns-c3492280817-983"
                                        >
                                          {" "}
                                          {!isEmpty(user) && (
                                            <div
                                              onClick={() => {
                                                navigate(
                                                  `/wallet/deposit/${res?._id}`,
                                                );
                                              }}
                                              _ngcontent-serverapp-c3492280817
                                              className="button btn-primary button__detail ng-tns-c3492280817-983"
                                            >
                                              <span
                                                _ngcontent-serverapp-c3492280817
                                                className="ng-tns-c3492280817-983"
                                              >
                                                Deposit
                                              </span>
                                            </div>
                                          )}
                                          <div style={{background:"linear-gradient(to bottom,#fff3,#fff0)",color:"white"}}
                                            onClick={() => setShow(res)}
                                            _ngcontent-serverapp-c3492280817
                                            className="button btn-primary button__detail ng-tns-c3492280817-983"
                                          >
                                            <span
                                              _ngcontent-serverapp-c3492280817
                                              className="ng-tns-c3492280817-983"
                                            >
                                              {t("Details")}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}

                                <div
                                  _ngcontent-serverapp-c2812446712
                                  className="prompt ng-tns-c2812446712-981 ng-star-inserted"
                                  style={{}}
                                >
                                  {t("EndOfPage")}
                                </div>
                              </app-waterfall-scroll>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-component>
                  </ng-component>
                </div>
              </div>
            </div>
          </ConditionalOutsideClick>
        </div>
      </app-popup-page>
      {!isEmpty(show) && <PromotionDetail show={show} setShow={setShow} />}
    </Layout>
  );
};

export default Promotions;
